module.exports = __webpack_public_path__ + "static/media/informationIcon-w.d706f216.svg";